module.exports = __webpack_public_path__ + "1f27d64fd6b024f219dfc933c493a03b.svg";